import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=5a86dcc4"
import script from "./Palette.vue?vue&type=script&lang=js"
export * from "./Palette.vue?vue&type=script&lang=js"
import style0 from "./Palette.vue?vue&type=style&index=0&id=5a86dcc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports